import { OpsiumUserShortResponse } from '@/modules/common';

import { ClientManager } from '../types';

export const mapClientManagerFromResponse = (user: OpsiumUserShortResponse): ClientManager => ({
  id: user.id?.toString(),
  email: user.email,
  name: user.name,
  avatar: user.profileImageUrl ?? undefined,
  isDeleted: user.isDeleted,
});
